/**
 * Represents the possible markers located on the map to show.
 */
export default class MarkerType {
  
  /**
   * It represents the Buildable Plan Pin on the map.
   */
  static get BuildablePlan() {
    return this.getInstance('buildeablePlan');
  }

  /**
   * It represents the Housing Development Pins, also called as Community Pins.
   */
  static get HousingDevelopment() {
    return this.getInstance('community');
  }

  /**
   * It represents the Plan Unit Pins.
   */
  static get PlanUnit() {
    return this.getInstance('plan');
  }

  /**
   * It represents the Spec Unit Pins.
   */
  static get SpecUnit() {
    return this.getInstance('spec');
  }

  static fromKey(key) {
    const map = {
      buildeablePlan: MarkerType.BuildablePlan,
      community: MarkerType.HousingDevelopment,
      plan: MarkerType.PlanUnit,
      spec: MarkerType.SpecUnit
    };
    return map[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new MarkerType(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(MarkerType, 'instances', { value: {} });
